import { UserManager, UserManagerSettings, WebStorageStateStore, InMemoryWebStorage } from "oidc-client-ts";
import { convertToIamLocale } from "translator-tools";
import { IIamSettings } from "./iamSettings";
import { IamStore } from "./iamStore";
import * as logger from "../../utils/logger";
import { DriveStore } from "../../store/reducers";
import { IamMobileSdkPopupNavigator } from "./IamMobileSdkPopupNavigator";
import { PopupCallBackType } from "../../services/iamService";
import constants from "../../constants";

const baseManager: UserManagerSettings = {
    authority: "",
    client_id: "",
    redirect_uri: window.location.origin + "/callback",
    silent_redirect_uri: window.location.origin + "/silent-renew.html",
    response_type: "code",
    scope: "openid profile email offline_access",
    post_logout_redirect_uri: window.location.origin,
    automaticSilentRenew: false,
    silentRequestTimeoutInSeconds: constants.IAM.SILENT_REFRESH_TIMEOUT_SECONDS,
    response_mode: "query"
};

export function getIamManager (settings: IIamSettings, store: DriveStore, storageKey: string, signinPopupCallback?: PopupCallBackType): UserManager | undefined {
    if (!settings || !settings.iamProviderType || !settings.loginUrl || !settings.clientId) {
        logger.error(logger.Source.IAM, `IamManager.getIamManager: settings are not valid: ${ JSON.stringify(settings) }`);
        return undefined;
    }

    let iamSettings: UserManagerSettings = {
        ...baseManager,
        authority: settings.loginUrl,
        client_id: settings.clientId,
        ui_locales: convertToIamLocale(settings.language),
        userStore: new WebStorageStateStore({ prefix: storageKey, store: new IamStore(store, settings) })
    };
    return new UserManager(iamSettings, window.geotabModules?.sso && signinPopupCallback ? new IamMobileSdkPopupNavigator(signinPopupCallback) : undefined);
}


export function getTempIamManager (settings: IIamSettings | undefined): UserManager | undefined {
    if (!settings || !settings.iamProviderType || !settings.loginUrl || !settings.clientId) {
        return undefined;
    }

    let iamSettings: UserManagerSettings = {
        ...baseManager,
        authority: settings.loginUrl,
        client_id: settings.clientId,
        ui_locales: convertToIamLocale(settings.language),
        userStore: new WebStorageStateStore({ store: new InMemoryWebStorage() })
     };
     return new UserManager(iamSettings);
}